/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Studio_BodyInputs */

const en_for_whom_studio_body = /** @type {(inputs: For_Whom_Studio_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Several trainers, group classes and one shared schedule.`)
};

const pl_for_whom_studio_body = /** @type {(inputs: For_Whom_Studio_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilku trenerów, zajęcia grupowe i jeden wspólny grafik.`)
};

/**
* | output |
* | --- |
* | "Several trainers, group classes and one shared schedule." |
*
* @param {For_Whom_Studio_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_studio_body = /** @type {((inputs?: For_Whom_Studio_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Studio_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_studio_body(inputs)
	return en_for_whom_studio_body(inputs)
});